export const isActiveElementInputable = () => {
	const activeElement = document.activeElement;
	const isInputFocused =
		activeElement &&
		(activeElement.tagName === 'INPUT' ||
			activeElement.tagName === 'TEXTAREA' ||
			// activeElement.contentEditable === 'true' ||
			activeElement.getAttribute('contenteditable') === 'true');
	return isInputFocused;
};
